"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var UpDown_exports = {};
__export(UpDown_exports, {
  default: () => UpDown_default
});
module.exports = __toCommonJS(UpDown_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.6602 3.92188C14.8034 3.92188 14.9206 3.97396 15.0117 4.07812C15.1159 4.16927 15.168 4.27995 15.168 4.41016V14.957L17.4336 12.6914C17.5378 12.5872 17.6549 12.5352 17.7852 12.5352C17.9284 12.5352 18.0456 12.5872 18.1367 12.6914C18.2409 12.7826 18.293 12.8997 18.293 13.043C18.293 13.1732 18.2409 13.2904 18.1367 13.3945L15.0898 16.4609C14.9727 16.5651 14.8294 16.6172 14.6602 16.6172C14.5039 16.6172 14.3672 16.5651 14.25 16.4609L11.1836 13.3945C11.0924 13.2904 11.0469 13.1732 11.0469 13.043C11.0469 12.8997 11.0924 12.7826 11.1836 12.6914C11.2878 12.5872 11.4049 12.5352 11.5352 12.5352C11.6784 12.5352 11.8021 12.5872 11.9062 12.6914L14.1719 14.957V4.41016C14.1719 4.27995 14.2174 4.16927 14.3086 4.07812C14.4128 3.97396 14.5299 3.92188 14.6602 3.92188ZM2.86328 7.18359C2.75911 7.28776 2.70703 7.41146 2.70703 7.55469C2.70703 7.6849 2.75911 7.79557 2.86328 7.88672C2.95443 7.99089 3.0651 8.04297 3.19531 8.04297C3.33854 8.04297 3.46224 7.99089 3.56641 7.88672L5.83203 5.62109V16.168C5.83203 16.2982 5.8776 16.4154 5.96875 16.5195C6.07292 16.6107 6.19661 16.6562 6.33984 16.6562C6.47005 16.6562 6.58073 16.6107 6.67188 16.5195C6.77604 16.4154 6.82812 16.2982 6.82812 16.168V5.62109L9.09375 7.88672C9.19792 7.99089 9.3151 8.04297 9.44531 8.04297C9.58854 8.04297 9.71224 7.99089 9.81641 7.88672C9.90755 7.79557 9.95312 7.6849 9.95312 7.55469C9.95312 7.41146 9.90755 7.28776 9.81641 7.18359L6.75 4.11719C6.63281 4.01302 6.48958 3.96094 6.32031 3.96094C6.16406 3.96094 6.02734 4.01302 5.91016 4.11719L2.86328 7.18359Z",
      fill: "currentColor"
    }
  )
);
const SvgUpDown = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var UpDown_default = SvgUpDown;
